const skinColors = ["#f7e4d5", "#f4e4c9", "#d6a07c", "#896551"];

export default skinColors;

export const eyeColors = ["#612500", "#0062ff", "#2e4f01", "#242424"];

export const hairColors = ["#b59838", "#b56219", "#382515", "#1f1c1a"];

export const clothingColors = ["#797889", "#98cc6f", "#f2779b", "#3d56a6"];
